import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmt = new Intl.NumberFormat("en-IN");

const STATUS_STYLES = {
  paid: "border-emerald-600/40 text-emerald-700",
  created: "border-[#6D28D9]/50 text-[#6D28D9]",
  failed: "border-rose-600/40 text-rose-700",
};

export const PaymentsTab = () => {
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    api.get("/admin/payments").then((r) => setPayments(r.data)).catch(() => {});
  }, []);

  const paid = payments.filter((p) => p.status === "paid");
  const total = paid.reduce((s, p) => s + (p.amount || 0), 0);

  return (
    <div data-testid="admin-payments-tab">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="font-display text-2xl font-semibold tracking-tight">Consultation Payments</h2>
          <p className="mt-1 text-sm text-slate-500">{paid.length} paid · ₹{fmt.format(total)} collected in booking fees.</p>
        </div>
      </div>
      <div className="mt-8 overflow-x-auto border border-slate-200">
        <table className="w-full min-w-[820px] text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-[#F6F4FD] font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-500">
              <th className="px-5 py-4">Received</th>
              <th className="px-5 py-4">Investor</th>
              <th className="px-5 py-4">Purpose</th>
              <th className="px-5 py-4">Preferred slot</th>
              <th className="px-5 py-4">Amount</th>
              <th className="px-5 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} data-testid={`admin-payment-row-${p.id}`} className="border-b border-slate-100 transition-colors hover:bg-violet-50">
                <td className="px-5 py-3 font-mono2 text-xs text-slate-500">{new Date(p.created_at).toLocaleString("en-IN")}</td>
                <td className="px-5 py-3">
                  <p className="font-medium text-slate-800">{p.name}</p>
                  <p className="font-mono2 text-[10px] tracking-wide text-slate-500">{p.email} · {p.phone}</p>
                </td>
                <td className="px-5 py-3 text-slate-500">{p.purpose}</td>
                <td className="px-5 py-3 font-mono2 text-xs text-slate-500">{[p.preferred_date, p.preferred_slot].filter(Boolean).join(" · ") || "—"}</td>
                <td className="px-5 py-3 font-mono2 text-sm text-slate-800">₹{fmt.format(p.amount)}</td>
                <td className="px-5 py-3">
                  <span className={`border px-2.5 py-1 font-mono2 text-[9px] uppercase tracking-[0.18em] ${STATUS_STYLES[p.status] || STATUS_STYLES.created}`}>{p.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {payments.length === 0 && (
          <p data-testid="admin-no-payments" className="px-5 py-12 text-center font-mono2 text-xs uppercase tracking-[0.25em] text-slate-500">No payments yet</p>
        )}
      </div>
    </div>
  );
};
